import { ReactNode, useEffect, useState } from 'react';
import { Drawer } from 'antd';
import { useShowTime } from 'common-package';
import CloseIcon from '@/assets/icon/DrawerClose.svg';
import { useKeyboardAndroid } from '@/hooks';
import cx from './index.module.scss';

const MemberDrawer = (props: {
  isShowTime?: boolean;
  isShowCloseIcon?: boolean;
  drawerStyle?: Record<string, string | number>;
  maskStyle?: React.CSSProperties;
  open: boolean;
  mask?: boolean;
  maskClosable?: boolean;
  width?: number;
  handleClose?: () => void;
  children?: ReactNode;
}) => {
  const [weekText, minuteText] = useShowTime('星期dd&HH:mm')?.split('&') || [];
  const isShowTime = props?.isShowTime ?? false;
  const drawerStyle = props?.drawerStyle ?? {};
  const maskStyle = props?.maskStyle ?? {};
  const isShowClose = props?.isShowCloseIcon ?? true;
  const keyboardVisible = useKeyboardAndroid();
  const [scrollHeight, setScrollHeight] = useState<number>(0);

  useEffect(() => {
    // 获取初始页面的高度 包括键盘的高度+可视区域
    const scrollHeight = document.documentElement.scrollHeight;
    setScrollHeight(scrollHeight);
  }, []);

  return (
    <Drawer
      styles={{
        body: { padding: '0  24px 30px ', ...drawerStyle },
        mask: props?.mask && { ...maskStyle },
        content: { height: scrollHeight + 'px' },
      }}
      open={props.open}
      mask={props?.mask ?? false}
      className={cx('member-drawer')}
      width={props?.width ?? 274}
      closable={false}
      maskClosable={props.maskClosable ?? false}
      onClose={() => {
        props?.handleClose && props?.handleClose();
      }}
    >
      <div className={cx('drawer-close')}>
        {isShowClose && (
          <img
            src={CloseIcon}
            alt="drawer-close"
            onClick={() => {
              props?.handleClose && props?.handleClose();
            }}
          />
        )}
      </div>

      {/* Note: 遮盖键盘上升导致的Drawer凸起问题 */}
      {keyboardVisible && <div className={cx('drawer-cover')} />}

      {isShowTime && (
        <div className={cx('time-text')}>
          <div className={cx('week')}>{weekText}</div>
          <div className={cx('line')}>|</div>
          <div className={cx('minute')}>{minuteText}</div>
        </div>
      )}
      <div className={cx('content-wrapper')}>{props.children}</div>
    </Drawer>
  );
};

export default MemberDrawer;
